import { Suspense, lazy } from 'react'

import { filterPermission } from 'src/utils/user'
import { PERMISSIONS_ACTIONS } from 'src/utils/user/constant'
import { PermissionActions } from 'src/services/posts'

import { ErrorBoundary } from 'src/components'
import { useUser } from 'src/hook/useUser'
import { useCommunityDetails } from '../../../context/communityDetailsContext'

const LiveButton = lazy(() =>
  import('communityManagement/live').then((mod) => ({ default: mod.LiveButton }))
)

const CreateLiveModal = lazy(() =>
  import('communityManagement/live').then((mod) => ({ default: mod.CreateLiveModal }))
)

const CreateLive = () => {
  const { community } = useCommunityDetails()
  const canCreateLive = filterPermission({
    specificPermission: PERMISSIONS_ACTIONS.WEBINAR_CREATE,
    permissionsUserList: community.permissions?.actions as PermissionActions[]
  })
  const { user } = useUser()

  const shouldHideButton = !canCreateLive

  if (shouldHideButton) {
    return null
  }

  return (
    <div className="_my-4" data-test="create-live">
      <ErrorBoundary>
        <Suspense fallback={null}>
          <LiveButton parentAppUser={user} />
          <CreateLiveModal parentAppUser={user} />
        </Suspense>
      </ErrorBoundary>
    </div>
  )
}

export default CreateLive
